import { useLocation } from 'react-router-dom';
import { PDFDownloadLink } from '@react-pdf/renderer';
import React from 'react';
import { Button, Col, Row, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import SingleQRCode from '../PdfFiles/SingleQRCode';
import moment from 'moment';

const ViewQRCode = () => {
    //--------------------------------------------------
    const location = useLocation();
    const data = location.state?.data;
    //--------------------------------------------------
    return (
        <>
            <Row className="justify-content-end align-items-center">
                <Col sm={4} md={4} className="d-flex justify-content-end align-items-center gap-2">
                    {data ? (
                        <PDFDownloadLink document={<SingleQRCode qr_data={data} />} fileName="qr_code.pdf">
                            {({ loading }) =>
                                loading ? (
                                    <Spinner animation="border" variant="success" />
                                ) : (
                                    <Button className="export-file justify-content-center w-140 align-items-center" style={{ background: '#198754', padding: '9px' }}>
                                        Export PDF
                                    </Button>
                                )
                            }
                        </PDFDownloadLink>
                    ) : (
                        <Spinner animation="border" variant="success" />
                    )}
                    <Link to="/qr-codes">
                        <Button className="theme-cancel-btn px-5 py-2">Close</Button>
                    </Link>
                </Col>
            </Row>
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="p-4 m-3">
                    <Row>
                        <Col sm={6} md={4} className="mb-4">
                            <div className="detail-small-heading">Name</div>
                            <div className="detail-value">{data?.name || 'N/A'}</div>
                        </Col>

                        <Col sm={6} md={4} className="mb-4">
                            <div className="detail-small-headingg">Agencies</div>
                            <div className="detail-value lower-case">{data?.agency_ids?.length || '0'}</div>
                        </Col>
                        <Col sm={6} md={4} className="mb-4">
                            <div className="detail-small-headingg">Routes</div>
                            <div className="detail-value lower-case">{data?.routes?.length || '0'}</div>
                        </Col>
                        <Col sm={6} md={4} className="mb-4">
                            <div className="detail-small-headingg">lat</div>
                            <div className="detail-value lower-case">{data?.lat || '0'}</div>
                        </Col>
                        <Col sm={6} md={4} className="mb-4">
                            <div className="detail-small-headingg">long</div>
                            <div className="detail-value lower-case">{data?.long || '0'}</div>
                        </Col>

                        <Col sm={6} md={4} className="mb-4">
                            <div className="detail-small-heading">Created At</div>
                            <div className="detail-value">{data?.created_at ? moment(data?.created_at).format('MM-DD-YYYY') : 'N/A'}</div>
                        </Col>
                        <Col sm={6} md={4} className="mb-4">
                            <div className="detail-small-heading">Manual Update</div>
                            <div className="detail-value">{data?.created_at ? moment(data?.created_at).format('MM-DD-YYYY') : 'N/A'}</div>
                        </Col>
                        <Col sm={6} md={4} className="mb-4">
                            <div className="detail-small-heading">System Update</div>
                            <div className="detail-value">{data?.created_at ? moment(data?.created_at).format('MM-DD-YYYY') : 'N/A'}</div>
                        </Col>
                    </Row>
                    {/* // qr code image */}
                    <Row className="d-flex justify-content-center">
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <img className="border" id="qrCode" width="200px" height="200px" src={data?.qrCode} alt="QR Code" />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default ViewQRCode;
